import {  getConferenceCallDetails,
  getSGMMeetingDetails,
  registerUserForConferenceCall,
  updateUserForConferenceCall,
  getRegisteredUserForConferenceCall, 
  getDateTimeNow,
  getConferenceCallStatus,
  getIcsFileForConferenceCall,
  getUserStatus,
  fetchLiveStreamUrl,
  setParticipantSession,
  livestreamEvents,
  endParticipantSession,
  saveEntryCode,
  fetchReplayAudio,
  updateMetadata,
  getReleaseInfo,
  convertUTCStringToLocalTimezone,
} from '@/service/api';
import { globalDispatch } from '@/utils/vuex';
import { getEmailAddressFromSession } from '@/utils/helper';
import {
FETCH_UPDATE,
FETCH_FAILURE,
FETCH_CONFERENCE_CALL_DETAILS_SUCCESS,
FETCH_TIME_DETAILS_SUCCESS,
FETCH_TIME_DETAILS_FAILURE,
FETCH_CONFERENCE_CALL_STATUS_SUCCESS,
FETCH_CONFERENCE_CALL_STATUS_FAILURE,
SET_CONFERENCE_CALL_STATUS,
SET_ASSISTANCE_MESSAGE_STATUS,
SET_HAS_CONFERENCE_STARTED,
FETCH_REGISTERED_USER_FOR_CALL_SUCCESS,
SET_PUBLIC_PARTICIPANT,
SET_SALES_REP,
FETCH_CONFERENCE_CALL_ICS_FILE_SUCCESS,
FETCH_CONFERENCE_CALL_ICS_FILE_FAILURE,
FETCH_USER_STATUS_SUCCESS,
FETCH_USER_STATUS_FAILURE,
FETCH_LIVESTREAM_URL,
SET_LIVESTREAM_PARTICIPANT_SESSION,
REPLAY_AUDIO_URL,
FETCH_RELEASE_INFO,
FETCH_UTC_TIME_STRING
} from '@/store/actions';
import Constants from '@/utils/constants';
import { commitLocalAndToGlobalService, globalCommit } from '@/utils/vuex';
import pollingService from '@/service/pollingService.js';
import moment from 'moment';
import cacheService from '@/service/cacheService.js';
import constants from '../../utils/constants';


const STOP_PARTICIPANT_POLLING = 'STOP_PARTICIPANT_POLLING';
const SET_PARTICIPANT_POLLING = 'SET_PARTICIPANT_POLLING';
const STOP_CALL_STATUS_POLLING = 'STOP_CALL_STATUS_POLLING';
const STOP_USER_STATUS_POLLING = 'STOP_USER_STATUS_POLLING';
const SET_CALL_STATUS_POLLING_TIME = 'SET_CALL_STATUS_POLLING_TIME';
const SET_IS_SLIDE_CONFERENCE_SHOW = 'SET_IS_SLIDE_CONFERENCE_SHOW';
const SET_IS_CONFERENCE_ONLY_SHOW = 'SET_IS_CONFERENCE_ONLY_SHOW';
const SET_IS_SMALL_GROUP_MEETING = 'SET_IS_SMALL_GROUP_MEETING';
const SET_IS_SMALL_GROUP_MEETING_OPERATOR_ASSISTED = 'SET_IS_SMALL_GROUP_MEETING_OPERATOR_ASSISTED';
const SET_IS_SMALL_GROUP_MEETING_WEBINAR_OPERATOR_ASSISTED = 'SET_IS_SMALL_GROUP_MEETING_WEBINAR_OPERATOR_ASSISTED';
const SET_IS_SLIDE_LIVE_VIDEO = 'SET_IS_SLIDE_LIVE_VIDEO';
const SET_IS_VIDEO_WEBINAR = 'SET_IS_VIDEO_WEBINAR';
const SET_IS_EVENT_VIEWER_ENABLED = 'SET_IS_EVENT_VIEWER_ENABLED';
const SET_IS_POLL_STILL_STREAMING_EVENT = 'SET_IS_POLL_STILL_STREAMING_EVENT';
const SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT = 'SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT';
const SET_UNIQUE_ID = 'SET_UNIQUE_ID';
const SET_CONFERENCE_PARAMS = 'SET_CONFERENCE_PARAMS';
export const ConferenceCallModule = {
namespaced: true,
state: {
conferenceCallDetails: {},
time: null,
conferenceCallStatus: {},
callStatus: null,
callStatusPollTime: Constants.PollingTimeIntervals.CallStatus,
showAssistanceMessage: null,
isPublicParticipant: null,
RegistrationType: Constants.RegistrationTypes.Standard,
salesRep: '',
registeredParticipant: {},
timeIntervalIncrease: null,
conferenceCallIcsFile: null,
userStatus: {},
liveStreamUrl: null,
replayAudioUrl: '',
ParticipantSession: {},
isParticipantPolling: false,
stopParticipantPolling: false,
stopConferenceStatusPolling: false,
stopUserStatusPolling: false,
hasConferenceCallStarted : false,
isSlidePlusConfShow: false,
isConfOnlyShow: false,
isSlidePlusLiveVideo: false,
isVideoWebinar: false,
isEventViewerEnabled: false,
isSmallGroupMeeting: false,
isSmallGroupMeetingOperatorAssisted: false,
isSmallGroupMeetingWebinarOperatorAssisted: false,
IsPollStillStreamingEvent: false,
IsPausePollStillStreamingEvent: false,
releaseInfo: [],
utcTimeString:'',
showId: '',
confId: '',
isListenOnly: false,
uniqueId: '',
},

actions: {

async fetchConferenceCallDetails({ commit, dispatch }, params) {
try {
globalCommit('service', commit, FETCH_UPDATE);
const result = await getConferenceCallDetails(params.showLink, params.confId);
const isSGM = !Array.isArray(result.data);
if(isSGM){
  try{
    var timezoneInfo = await convertUTCStringToLocalTimezone(result.data.startDateUTC, Constants.TimezoneFormat);
    commitLocalAndToGlobalService(commit, FETCH_UTC_TIME_STRING, timezoneInfo.data);
  }catch (err) {
    commitLocalAndToGlobalService(commit, FETCH_UTC_TIME_STRING, []);
  }
}
try {
  var releaseInfoResponse = await getReleaseInfo();
  commitLocalAndToGlobalService(commit, FETCH_RELEASE_INFO, releaseInfoResponse.data[0]);
  globalDispatch('global', dispatch, 'setHideMaintenanceBanner', false);
} catch (err) {
  commitLocalAndToGlobalService(commit, FETCH_RELEASE_INFO, []);
  globalDispatch('global', dispatch, 'setHideMaintenanceBanner', true);
}           
globalDispatch('global', dispatch, 'setIsAdminView', false);

if (isSGM) {
  const details = {
    Id: '',
    PresId: result.data.presId,
    StartDate: result.data.startDate,
    EndDate: result.data.endDate,
    Timezone: result.data.timezone,
    PreMeetingAccessMinutes: result.data.preMeetingAccessMinutes,
    PostMeetingAccessMinutes: result.data.postMeetingAccessMinutes,
    RequireVerification: true,
    StartDateUTC: result.data.startDateUTC,
    EndDateUTC: result.data.endDateUTC,
    StartTimeUtc: result.data.startDateUTC,
    EndTimeUtc: result.data.endDateUTC,
    Type: result.data.type,
    MeetingId: result.data.meetingId,
    PresTitle: result.data.PresTitle,
    UnderwriterName: result.data.UnderwriterName,
    PublicCallEndTimeUtc: result.data.PublicCallEndTimeUtc
  }
  commitLocalAndToGlobalService(commit, FETCH_CONFERENCE_CALL_DETAILS_SUCCESS, details);
  dispatch('setSmallGroupMeetingType', result.data.type);
} else {
  commitLocalAndToGlobalService(commit, FETCH_CONFERENCE_CALL_DETAILS_SUCCESS, result.data[0]);
  dispatch('setIsSlidePlusConferenceShow');
  dispatch('setIsConferenceOnlyShow');
  dispatch('setIsSlidePlusLiveVideo');
  dispatch('setIsVideoWebinar');
  dispatch('setIsEventViewerEnabled');
}    
} catch (error) {
//removing toast message on error.
globalCommit('service', commit, FETCH_UPDATE);
throw error;
}
},

async getRegisteredUserForCall({ state, commit, rootGetters, dispatch }, poll_request = false) {
if(poll_request && state.stopParticipantPolling) {
return; 
}
const { Id, PresId } = state.conferenceCallDetails;
const params = {
emailAddress: rootGetters['login/GET_USER_EMAIL_ADDRESS'],
registered: true
};

globalCommit('service', commit, FETCH_UPDATE);
try {
const registeredParticipantList = await getRegisteredUserForConferenceCall(PresId, Id, params, !poll_request);
let registeredParticipant = {};
if (registeredParticipantList.data.length > 0) {
  registeredParticipant = registeredParticipantList.data[0];
  commitLocalAndToGlobalService(commit, 'SET_PUBLIC_PARTICIPANT', registeredParticipant.IsPublicParticipant);
  commitLocalAndToGlobalService(commit, 'SET_SALES_REP', registeredParticipant.SalesRep);
}
commitLocalAndToGlobalService(commit, FETCH_REGISTERED_USER_FOR_CALL_SUCCESS, registeredParticipant);
if(poll_request) { 
  pollingService.start_poll(() => { 
  dispatch('getRegisteredUserForCall', true); 
  }, Constants.PollingTimeIntervals.ParticipantsApi); 
} 
} catch (error) {
if (poll_request) {
  if (error.response === undefined || error.response.status !== 403) {
    pollingService.start_poll(() => { 
      dispatch('getRegisteredUserForCall', true); 
    }, Constants.PollingTimeIntervals.ParticipantsApi);
  }
}        
else
{
  commitLocalAndToGlobalService(commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
}        
}
},

async registerForConferenceCall({ state, commit, rootGetters }) {
const { Id, PresId } = state.conferenceCallDetails;
const params = {
EmailAddress: rootGetters['login/GET_USER_EMAIL_ADDRESS'],
IsPublicParticipant: state.isPublicParticipant ? state.isPublicParticipant : sessionStorage.getItem('isPublicParticipant'),
RegistrationType: state.isListenOnly ? Constants.RegistrationTypes.ListenOnly : Constants.RegistrationTypes.Standard,
Metadata: JSON.parse(sessionStorage.getItem('registrationFields'))
};

globalCommit('service', commit, FETCH_UPDATE);
try {
const registeredParticipant = await registerUserForConferenceCall(PresId, Id, params);
sessionStorage.setItem(Constants.SessionStorageKeys.RegistrationSuccessful, true);

// Clearing Participant Cache when registering user
cacheService.clearCacheValue(`${Constants.CacheKeysPrefix.ParticipantData}-${Id}`);

const { ShowPassword } = rootGetters['presentation/GET_PASSWORD_DETAILS'];
await saveEntryCode(getEmailAddressFromSession(), { ShowPassword, ConferenceId: Id});
commitLocalAndToGlobalService(commit, FETCH_REGISTERED_USER_FOR_CALL_SUCCESS, registeredParticipant.data);
} catch (error) {
commitLocalAndToGlobalService(commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
}
},

async updateRegisteredParticipantForConferenceCall({ state, commit, rootGetters }) {
const { Id, PresId } = state.conferenceCallDetails;
const params = {
EmailAddress: rootGetters['login/GET_USER_EMAIL_ADDRESS'],
IsPublicParticipant: state.isPublicParticipant ? state.isPublicParticipant : sessionStorage.getItem('isPublicParticipant'),
RegistrationType: state.isListenOnly ? Constants.RegistrationTypes.ListenOnly : Constants.RegistrationTypes.Standard,
Metadata: JSON.parse(sessionStorage.getItem('registrationFields'))
};

globalCommit('service', commit, FETCH_UPDATE);
try {
  const registeredParticipant = await updateUserForConferenceCall(PresId, Id, state.registeredParticipant.Id, params);
  commitLocalAndToGlobalService(commit, FETCH_REGISTERED_USER_FOR_CALL_SUCCESS, registeredParticipant.data);
  } catch (error) {
  commitLocalAndToGlobalService(commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
}
},


/**
* Pollling function for Getting Date Time from Server
* @param {Boolean} cancelPoll 
*/
async fetchDateTimeNow({ state, commit, dispatch }, cancelInterval) {
if(state.timeIntervalIncrease && cancelInterval ){
clearInterval(state.timeIntervalIncrease);
}else{
try {

    const response = await getDateTimeNow();
    var serverTime = response.headers.date;

    commitLocalAndToGlobalService(commit, FETCH_TIME_DETAILS_SUCCESS, serverTime);

    state.timeIntervalIncrease = setInterval(function(){

     serverTime = moment(serverTime).add(1,'s')._d;
      commitLocalAndToGlobalService(commit, FETCH_TIME_DETAILS_SUCCESS, serverTime);

    }, Constants.PollingTimeIntervals.TimeApi);
   
    

} catch (error) {
  commitLocalAndToGlobalService(commit, FETCH_TIME_DETAILS_FAILURE, error);
}
}

},

startConferenceCallStatusPolling({commit, dispatch}) {
commit(STOP_CALL_STATUS_POLLING, false);
dispatch('fetchConferenceCallStatus', true);    
},

stopConferenceCallStatusPolling({commit}) {
commit(STOP_CALL_STATUS_POLLING, true);
},

slowCallStatusPolling({commit}) {
commit(SET_CALL_STATUS_POLLING_TIME, Constants.PollingTimeIntervals.CallStatusSlowPoll);
},

/**
* polling function to get conference call status 
* @param {Boolean} cancelPoll 
*/
async fetchConferenceCallStatus({ state, commit, dispatch }, poll_request = false) {
setTimeout(async () => {
if (poll_request && state.stopConferenceCallStatusPolling) {
  return;
}
else {
  try {
    const statusResponse = await getConferenceCallStatus(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id, !poll_request);
    if(statusResponse.data.Status  === constants.ConferenceStatus.NotStarted){
      statusResponse.data.Status = constants.ConferenceStatus.Available;
    }

    commitLocalAndToGlobalService(commit , FETCH_CONFERENCE_CALL_STATUS_SUCCESS, statusResponse.data);
    
    if(poll_request) {
      pollingService.start_poll(() => {
        dispatch('fetchConferenceCallStatus', true);
      }, state.callStatusPollTime);
    }

  } catch (error) {
    if (poll_request) {
      if (error.response === undefined || error.response.status !== 403) {
        pollingService.start_poll(() => {
          dispatch('fetchConferenceCallStatus', true);
        }, state.callStatusPollTime); 
      }
    }
    else
    {
      commitLocalAndToGlobalService(commit , FETCH_CONFERENCE_CALL_STATUS_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
    }          
  }
}
});
},

startUserStatusPolling({commit, dispatch}) {
commit(STOP_USER_STATUS_POLLING, false);
dispatch('fetchUserStatus');    
},

stopUserStatusPolling({commit}) {
commit(STOP_USER_STATUS_POLLING, true);
},

startPollStillStreamingEvent({state, commit, dispatch}) {
if(!state.IsPollStillStreamingEvent && !!(state.ParticipantSession.Id)){
commit(SET_IS_POLL_STILL_STREAMING_EVENT, true);
dispatch('pollStillStreamingEvent');
}
commit(SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT, false);
},

stopPollStillStreamingEvent({commit}) {
commit(SET_IS_POLL_STILL_STREAMING_EVENT, false);
commit(SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT, true);
},

pausePollStillStreamingEvent({commit}) {
commit(SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT, true);
},

/**
* polling function to get user status 
* @param {Boolean} cancelPoll 
*/
async fetchUserStatus({ state, commit, dispatch }) {
setTimeout(async () => {
if (state.stopUserStatusPolling) {
  return;
}
else {
  try {
    const statusResponse = await getUserStatus(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id, false);

    commitLocalAndToGlobalService(commit, FETCH_USER_STATUS_SUCCESS, statusResponse.data);

      pollingService.start_poll(() => {
        dispatch('fetchUserStatus');
      }, Constants.PollingTimeIntervals.UserStatus);

  } catch (error) {
    if (error.response === undefined || error.response.status !== 403) {
      pollingService.start_poll(() => {
        dispatch('fetchUserStatus');
      }, Constants.PollingTimeIntervals.UserStatus);
    }
  }
}
});
},

async setCallStatusOnPage({ commit }, status) {
commitLocalAndToGlobalService(commit, SET_CONFERENCE_CALL_STATUS, status);
},

async setAssistanceMessage({ commit }, status) {
commitLocalAndToGlobalService(commit, SET_ASSISTANCE_MESSAGE_STATUS, status);
},
async setHasConferenceStarted({ commit }, hasConferenceCallStarted) {
commitLocalAndToGlobalService(commit, SET_HAS_CONFERENCE_STARTED, hasConferenceCallStarted);
},

async fetchLiveStreamUrl({ state, commit, dispatch }, poll_request = false){
try{
globalCommit('service', commit, FETCH_UPDATE);
const result = await fetchLiveStreamUrl(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id, !poll_request);
commitLocalAndToGlobalService(commit, FETCH_LIVESTREAM_URL, result.data.Url);
}  catch(error) {
globalCommit(
  'service',
  commit,
  FETCH_CONFERENCE_CALL_STATUS_FAILURE,
  Constants.ErrorMessages.GenericToasterErrorMessage
  );
  commitLocalAndToGlobalService(commit, FETCH_LIVESTREAM_URL, null);
  throw new Error(error);
}
},

async setParticipantSession({ state, commit, dispatch }, joinType) {
try{
  globalCommit('service', commit, FETCH_UPDATE);
  const payload = {
    ConferenceId: state.conferenceCallDetails.Id,
    ParticipantType: joinType
  };
  const result = await setParticipantSession(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id, payload);
  commitLocalAndToGlobalService(commit, SET_LIVESTREAM_PARTICIPANT_SESSION, result.data);
  dispatch("liveStreamEvents",'Play');
}catch(error){
globalCommit(
  'service',
  commit,
  FETCH_CONFERENCE_CALL_STATUS_FAILURE,
  Constants.ErrorMessages.GenericToasterErrorMessage
  );
}
},

async updateMetadata({ commit }, params) {
globalCommit('service', commit, FETCH_UPDATE);
try {
const metadata = await updateMetadata(params.email, params.show);
commitLocalAndToGlobalService(commit, metadata.data);
} catch (err) {
commitLocalAndToGlobalService(commit, Constants.ErrorMessages.GenericToasterErrorMessage);
}
},

async endParticipantSession({ state, commit }) {
try{
  if(Object.entries(state.ParticipantSession).length !== 0){
    state.ParticipantSession.IsActive = false;
    await endParticipantSession(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id, state.ParticipantSession);
    commitLocalAndToGlobalService(commit, FETCH_LIVESTREAM_URL, null);
    commitLocalAndToGlobalService(commit, REPLAY_AUDIO_URL, null);
    commitLocalAndToGlobalService(commit, SET_LIVESTREAM_PARTICIPANT_SESSION, {});
    commit(SET_IS_POLL_STILL_STREAMING_EVENT, false);
    commit(SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT, true);
  }
}catch(error){
globalCommit(
  'service',
  commit,
  FETCH_CONFERENCE_CALL_STATUS_FAILURE,
  Constants.ErrorMessages.GenericToasterErrorMessage
  );
}
},

liveStreamEvents({ state, commit}, event) {
try{
// globalCommit('service', commit, FETCH_UPDATE);

let payload = {
  ParticipantId: state.ParticipantSession.Id,
}
if(event.type){
  payload = { ...payload,
    EventType: event.type,
    From: event.From,
    To: event.To
  };
}else{
  payload = { ...payload,
    EventType: event
  };
}
livestreamEvents(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id, payload);
}catch(error) {
globalCommit(
  'service',
  commit,
  FETCH_CONFERENCE_CALL_STATUS_FAILURE,
  Constants.ErrorMessages.GenericToasterErrorMessage
  );
}
},

async fetchReplayAudio({state, commit}) {
try {
commitLocalAndToGlobalService(commit, REPLAY_AUDIO_URL, null);
const replayAudioUrl = await fetchReplayAudio(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id);
if(!state.conferenceCallDetails.AskForPublicPrivate){
  commitLocalAndToGlobalService(commit, REPLAY_AUDIO_URL, replayAudioUrl.data.Url);
}else {
  if (state.registeredParticipant.IsPublicParticipant === false) {
    commitLocalAndToGlobalService(commit, REPLAY_AUDIO_URL, replayAudioUrl.data.PrivateUrl);
  } else {
    commitLocalAndToGlobalService(commit, REPLAY_AUDIO_URL, replayAudioUrl.data.PublicUrl);            
  }
} 
}catch(error) {
globalCommit(
  'service',
  commit,
  FETCH_CONFERENCE_CALL_STATUS_FAILURE,
  Constants.ErrorMessages.GenericToasterErrorMessage
);
}
},

async fetchIcsFileForConferenceCall({state, commit}){
try {
globalCommit('service', commit, FETCH_UPDATE);
const result = await getIcsFileForConferenceCall(state.conferenceCallDetails.PresId, state.conferenceCallDetails.Id);
commitLocalAndToGlobalService(commit, FETCH_CONFERENCE_CALL_ICS_FILE_SUCCESS, result.data);
} catch (error) {
globalCommit(
  'service',
  commit,
  FETCH_CONFERENCE_CALL_ICS_FILE_FAILURE,
  Constants.ErrorMessages.GenericToasterErrorMessage
);
}
},

startParticipantPolling({state, commit, dispatch}) {
if(!state.isParticipantPolling){
commit(STOP_PARTICIPANT_POLLING, false);
commit(SET_PARTICIPANT_POLLING, true);
dispatch('getRegisteredUserForCall', true);  
}
},

stopParticipantPolling({commit}) {
commit(STOP_PARTICIPANT_POLLING, true);
commit(SET_PARTICIPANT_POLLING, false);
},

resetConferenceStatus({commit}) {
commit(FETCH_CONFERENCE_CALL_STATUS_SUCCESS, {}); 
},

setIsSlidePlusConferenceShow({commit, state}) {  
commit(SET_IS_SLIDE_CONFERENCE_SHOW, (state.conferenceCallDetails.ShowType === Constants.ShowTypes.confCallAndSlides || state.conferenceCallDetails.ShowType === Constants.ShowTypes.simuLiveConferenceCallAndSlide));
},

setIsConferenceOnlyShow({commit, state}) {  
commit(SET_IS_CONFERENCE_ONLY_SHOW, (state.conferenceCallDetails.ShowType === Constants.ShowTypes.confCallOnly || state.conferenceCallDetails.ShowType === Constants.ShowTypes.simuLiveConferenceCallOnly));
},

setIsSlidePlusLiveVideo({commit, state}) { 
commit(SET_IS_SLIDE_LIVE_VIDEO, state.conferenceCallDetails.ShowType === Constants.ShowTypes.liveVideoSlides);
},

setIsVideoWebinar({commit, state}) { 
commit(SET_IS_VIDEO_WEBINAR, state.conferenceCallDetails.ShowType === Constants.ShowTypes.videoWebinar);
},

setIsEventViewerEnabled({commit, state}) { 
commit(SET_IS_EVENT_VIEWER_ENABLED, state.conferenceCallDetails.EnableEventViewerForConferencing);
},

setSmallGroupMeetingType({commit}, data) {
if (data === 13) {
commit(SET_IS_SMALL_GROUP_MEETING);
} else if (data === 14) {
commit(SET_IS_SMALL_GROUP_MEETING_OPERATOR_ASSISTED);
} else if (data === 15) {
commit(SET_IS_SMALL_GROUP_MEETING_WEBINAR_OPERATOR_ASSISTED);
}
},

pollStillStreamingEvent({commit, state, dispatch}) {
if (state.IsPollStillStreamingEvent) {
if (!state.IsPausePollStillStreamingEvent) {
  dispatch("liveStreamEvents", 'IsStillStreaming');
}
pollingService.start_poll(() => {
  dispatch('pollStillStreamingEvent');
}, Constants.PollingTimeIntervals.StillStreamingEvent);
}
}
},

mutations: {
[FETCH_CONFERENCE_CALL_DETAILS_SUCCESS]: (state, conferenceCallDetails) => {
state.conferenceCallDetails = conferenceCallDetails;
},
[FETCH_REGISTERED_USER_FOR_CALL_SUCCESS]: (state, registeredParticipant) => {
state.registeredParticipant = registeredParticipant;
},
[SET_PUBLIC_PARTICIPANT]: (state, isPublicParticipant) => {
state.isPublicParticipant = isPublicParticipant;
},
[SET_SALES_REP]: (state, salesRep) => {
state.salesRep = salesRep;
},

[FETCH_TIME_DETAILS_SUCCESS]: (state, time) => {
state.time = time;
},
[FETCH_CONFERENCE_CALL_STATUS_SUCCESS]: (state, conferenceCallStatus) => {
state.conferenceCallStatus = conferenceCallStatus;
},
[SET_CONFERENCE_CALL_STATUS]: (state, callStatus) => {
state.callStatus = callStatus;
},
[SET_ASSISTANCE_MESSAGE_STATUS]: (state, showAssistanceMessage) => {
state.showAssistanceMessage = showAssistanceMessage;
},
[SET_HAS_CONFERENCE_STARTED]: (state, hasConferenceCallStarted) => {
state.hasConferenceCallStarted = hasConferenceCallStarted;
},
[FETCH_CONFERENCE_CALL_ICS_FILE_SUCCESS]: (state, conferenceCallIcsFile)=>{
state.conferenceCallIcsFile = conferenceCallIcsFile;
},
[FETCH_USER_STATUS_SUCCESS]: (state, userStatus) => {
state.userStatus = userStatus;
},  
[FETCH_LIVESTREAM_URL]: (state, liveStreamUrl)=>{
state.liveStreamUrl = liveStreamUrl;
},
[REPLAY_AUDIO_URL]: (state, replayAudioUrl)=>{
state.replayAudioUrl = replayAudioUrl;
},
[SET_LIVESTREAM_PARTICIPANT_SESSION]: (state, ParticipantSession)=>{
state.ParticipantSession = ParticipantSession;
},
[STOP_PARTICIPANT_POLLING]: (state, stopPolling) => {
state.stopParticipantPolling = stopPolling;
},
[SET_PARTICIPANT_POLLING]:(state, isPolling) => {
state.isParticipantPolling = isPolling;
},
[STOP_CALL_STATUS_POLLING]: (state, stopPolling) => {
state.stopConferenceCallStatusPolling = stopPolling;
},
[SET_CALL_STATUS_POLLING_TIME]: (state, pollTime) => {
state.callStatusPollTime = pollTime;
},
[STOP_USER_STATUS_POLLING]: (state, stopPolling) => {
state.stopUserStatusPolling = stopPolling;   
},
[SET_IS_SLIDE_CONFERENCE_SHOW]: (state, isSlidePlusConfShow) => {
state.isSlidePlusConfShow = isSlidePlusConfShow;
},
[SET_IS_CONFERENCE_ONLY_SHOW]: (state, isConfOnlyShow) => {
state.isConfOnlyShow = isConfOnlyShow;
},
[SET_IS_SLIDE_LIVE_VIDEO]: (state, isSlidePlusLiveVideo) => {
state.isSlidePlusLiveVideo = isSlidePlusLiveVideo;
},
[SET_IS_VIDEO_WEBINAR]: (state, isVideoWebinar) => {
state.isVideoWebinar = isVideoWebinar;
},
[SET_IS_EVENT_VIEWER_ENABLED]: (state, isEventViewerEnabled) => {
state.isEventViewerEnabled = isEventViewerEnabled;
},
[SET_IS_SMALL_GROUP_MEETING]: (state) => {
state.isSmallGroupMeeting = true;
},
[SET_IS_SMALL_GROUP_MEETING_OPERATOR_ASSISTED]: (state) => {
state.isSmallGroupMeetingOperatorAssisted = true;
},
[SET_IS_SMALL_GROUP_MEETING_WEBINAR_OPERATOR_ASSISTED]: (state) => {
state.isSmallGroupMeetingWebinarOperatorAssisted = true;
},
[SET_IS_POLL_STILL_STREAMING_EVENT]: (state, pollingStarted) => {
state.IsPollStillStreamingEvent = pollingStarted; 
},
[SET_IS_PAUSE_POLL_STILL_STREAMING_EVENT]: (state, pausePolling) => {
state.IsPausePollStillStreamingEvent = pausePolling; 
},
[FETCH_RELEASE_INFO]: (state, releaseData) => {
state.releaseInfo = releaseData;
},
[FETCH_UTC_TIME_STRING]: (state, timeString) => {
state.utcTimeString = timeString;
},
[SET_UNIQUE_ID]: (state, uniqueId) => {
state.uniqueId = uniqueId;
},
[SET_CONFERENCE_PARAMS](state, { showId, confId, isListenOnly }) {
state.showId = showId;
state.confId = confId;
state.isListenOnly = isListenOnly;
}
},

getters: {
GET_CONFERENCE_CALL_DETAILS: state => state.conferenceCallDetails,
GET_PUBLIC_PARTICIPANT: state => state.isPublicParticipant,
GET_SALES_REP: state => state.salesRep,
GET_REGISTERED_USER_FOR_CALL: state => state.registeredParticipant,
GET_TIME_DETAILS: state => state.time,
GET_CONFERENCE_CALL_STATUS: state => state.conferenceCallStatus,
GET_CONFERENCE_CALL_PAGE_STATUS: state => state.callStatus,
GET_ASSISTANCE_MESSAGE_STATUS: state => state.showAssistanceMessage,
GET_CONFERENCE_CALL_ICS_FILE: state => state.conferenceCallIcsFile,
GET_USER_STATUS: state => state.userStatus.Status,  
GET_LIVESTREAM_URL: state => state.liveStreamUrl,
GET_REPLAYAUDIO_URL: state => state.replayAudioUrl,
GET_PARTICIPANT_ACCESS_REVOKED: state => state.registeredParticipant.AccessRevoked,
GET_PUBLIC_PARTICIPANT_ACCESS_REVOKED: state => state.isPublicParticipant &&  state.conferenceCallDetails.PublicCallEndTimeUtc,
GET_HAS_CONFERENCE_STARTED: state => state.hasConferenceCallStarted,
GET_IS_SLIDE_CONF_SHOW: state => state.isSlidePlusConfShow,
GET_IS_CONF_ONLY_SHOW: state => state.isConfOnlyShow,
GET_IS_SLIDE_LIVE_VIDEO: state => state.isSlidePlusLiveVideo,
GET_IS_VIDEO_WEBINAR: state => state.isVideoWebinar,
GET_IS_EVENT_VIEWER_ENABLED: state => state.isEventViewerEnabled,
GET_IS_SMALL_GROUP_MEETING_TYPE: state => state.isSmallGroupMeeting || state.isSmallGroupMeetingOperatorAssisted || state.isSmallGroupMeetingWebinarOperatorAssisted, 
GET_IS_SMALL_GROUP_MEETING: state => state.isSmallGroupMeeting,
GET_IS_SMALL_GROUP_MEETING_OPERATOR_ASSISTED: state => state.isSmallGroupMeetingOperatorAssisted,
GET_IS_SMALL_GROUP_MEETING_WEBINAR_OPERATOR_ASSISTED: state => state.isSmallGroupMeetingWebinarOperatorAssisted,
FETCH_RELEASE_INFO: state => state.releaseInfo,
FETCH_UTC_TIME_STRING: state => state.utcTimeString,
GET_SHOW_ID: state => state.showId,
GET_CONF_ID: state => state.confId,
GET_IS_LISTEN_ONLY: state => state.isListenOnly,
GET_UNIQUE_ID: state => state.uniqueId,
}
}
